import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-configuration-modal',
  templateUrl: './configuration-modal.component.html',
  styleUrls: ['./configuration-modal.component.css']
})
export class ConfigurationModalComponent implements OnInit, OnDestroy {

  @ViewChild('values', { static: false }) valueRef: ElementRef | undefined;

  @Input() configurationData: any;
  @Input() configurationAdd: any;
  @Input() configurationView: any;
  @Input() configurationEdit: any;
  @Input() tabType: any;
  @Input() siteId: any;
  @Input() siteConfigurationsiteIdData: any;

  form: FormGroup;
  isValidJson: boolean = true;
  formSubmitted: boolean = false;
  selectedStatus: any;
  type: any;
  uom: any;
  attributeIdList: any = [];
  siteList: any = [];
  isShown: any;
  errorMessage: any = null;

  private _loading: boolean = false;
  private _configIds: boolean = false;
  private _postData: any;
  private _rangemin: number = 0;
  private _rangemax: number = 0;
  private _attributes: any = ['typ', 'unitOfMeasurement'];
  private _attributeListForConfig: any = [];
  private _selectedItems: any = [];
  private _afterClosedSubscription: Subscription;
  private _siteListSubscription: Subscription;
  private _attributeListSubscription: Subscription;
  private _saveConfigSubscription: Subscription;
  private _saveSubscription: Subscription;
  
  constructor(
    private _activeModal: NgbActiveModal,
    private _fb: FormBuilder,
    private _service: ServicecallService,
    private _dialog: MatDialog
  ) {
    this.form = this._fb.group({
      siteId: ['', [Validators.required]],
      attributeList: ['', [Validators.required]],
      attribute: [this.configurationData ? this.configurationData.attribute : '', [Validators.required, Validators.pattern(/^[a-z]+((\d)|([A-Z0-9][a-z0-9]+))*([A-Z])?$/)]],
      description: [this.configurationData ? this.configurationData.description : '', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      type: [],
      uom: [],
      rangemin: [],
      rangemax: [],
      mandatory: [],
      values: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this._checkValidity();
    this._loadConfigurationModalData();
  }
  ngOnDestroy(): void {
    this._afterClosedSubscription?.unsubscribe();
    this._siteListSubscription?.unsubscribe();  
    this._attributeListSubscription?.unsubscribe(); 
    this._saveConfigSubscription?.unsubscribe(); 
    this._saveSubscription?.unsubscribe(); 
    
  }
  closeModal() {
    if (this.form.dirty) {
      let dialogRef = this._dialog.open(AlertDialogComponent, {
        data: { msg: Messages.UNSAVED_CHANGES, type: null },
        disableClose: true
      });
      this._afterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this._activeModal.close();
        }
      });
    }
    else {
      this._activeModal.close();
    }
  }

  validateJSON() {
    try {
      if (Object.getOwnPropertyNames(JSON.parse(this.form.value.values)).length == 0) {
        this.isValidJson = false;
      } else {
        JSON.parse(this.form.value.values);
        this.isValidJson = true;
      }
    } catch (e) {
      this.isValidJson = false;
      return e;
    }

    if (!this.isValidJson) {
      return;
    }
    this.form.value.values = JSON.parse(this.form.value.values);
  }

  formatJSON() {
    if (this.isValidJson) {
      this.valueRef!.nativeElement.value = JSON.stringify(JSON.parse(this.valueRef!.nativeElement.value), null, 4);
      this.form.value.values = JSON.parse(this.valueRef!.nativeElement.value);
    }
  }

  validateButtonStatus() {
    if (this.isValidJson) {
      return 'fas fa-check-circle m-1 ';
    }
    else {
      return 'm-0'
    }
  }
  getAttribList(event: {
    isUserInput: any;
    source: { value: any; selected: any };
  }) {
    if (event.isUserInput) {
      if (event.source.selected === true) {
        this.siteId = event.source.value;
        this._getAttributeList();
      }
    }
  }
  getValues(event: {
    isUserInput: any;
    source: { value: any; selected: any };
  }) {
    if (event.isUserInput) {
      if (event.source.selected === true) {
        this._selectedItems = event.source.value;
        this._loadAttributeData();
        this.form.controls['attribute'].disable();
        this.form.controls['description'].disable();
        this.form.controls['uom'].disable();
        this.form.controls['rangemax'].disable();
        this.form.controls['rangemin'].disable();
        this.form.controls['mandatory'].disable();
      }
    }
  }
  
  onSubmit() {
    this.formSubmitted = true;
    if (this.form.invalid) {
      return;
    }
    if (!this.isValidJson) {
      return;
    }
    if (this.configurationAdd) {
      this._saveConfiguration();
    } else if (this.configurationEdit) {
      this._updateConfiguration();
    }
  }

  get formValues() {
    return this.form.controls;
  }

  private _checkValidity() {
    if (this.tabType === 'site') {
      this.isShown = 'site';
      this._getSiteList();
    } else if (this.tabType === 'tenant') {
      this.isShown = 'tenant';
      this._getAttributeList();
    } else if (this.tabType === 'global') {
      this.isShown = 'global';
      this._getAttributeList();
    }
  }

  private _loadConfigurationModalData() {
    this.type = this._service.getConfiguration('typ') ? this._service.getConfiguration('typ').scope : [];
    this.uom = this._service.getConfiguration('unitOfMeasurement') ? this._service.getConfiguration('unitOfMeasurement').measurement : [];
    if (this.configurationData) {
      this._rangemin = this.configurationData['range'].min;
      this._rangemax = this.configurationData['range'].max;
      if (this.configurationView) {
        this.form.disable();
      }
      if (this.tabType === 'site' || this.tabType === 'tenant') {
        this.form.controls['attribute'].disable();
        this.form.controls['description'].disable();
        this.form.controls['uom'].disable();
        this.form.controls['rangemax'].disable();
        this.form.controls['rangemin'].disable();
        this.form.controls['mandatory'].disable();
      } else {
        this.form.controls['attribute'].disable();
        this.form.controls['description'].disable();
      }
    }
    this._patchValues();
  }

  //   this.loading = true;
  //   this._service.configurationsInfo(this.attributes).subscribe((results: any) => {
  //     this.loading = false;
  //     let configList: any = results['response'];
  //     configList.forEach((element: any) => {
  //       if (element['attribute'] === 'typ') {
  //         this.type = element['values'].scope;
  //       }
  //       if (element['attribute'] === 'unitOfMeasurement') {
  //         this.uom = element['values'].measurement;
  //       }
  //     })
  //     if (this.configurationData) {
  //       this.rangemin = this.configurationData['range'].min;
  //       this.rangemax = this.configurationData['range'].max;
  //       if (this.configurationView) {
  //         this.form.disable();
  //       }
  //       if (this.tabType === 'site' || this.tabType === 'tenant') {
  //         this.form.controls['attribute'].disable();
  //         this.form.controls['description'].disable();
  //         this.form.controls['uom'].disable();
  //         this.form.controls['rangemax'].disable();
  //         this.form.controls['rangemin'].disable();
  //         this.form.controls['mandatory'].disable();
  //       } else {
  //         this.form.controls['attribute'].disable();
  //         this.form.controls['description'].disable();
  //       }
  //     }
  //     this.patchValues();
  //   });
  // }

  private _getSiteList() {
    this.siteList.length = 0;
    this._siteListSubscription = this._service.siteList(this.siteId).subscribe((res: any) => {
      this.siteList = res['response']['data'];
      const site = sessionStorage.getItem('plantProfileSiteId') ?
        JSON.parse(sessionStorage.getItem('plantProfileSiteId') || '{}') : null;
      if (site) {
        this.siteList = this.siteList.filter((item: any) => item._id === site);
        this.form.patchValue({ siteId: this.siteList[0]._id });
        this.siteId = this.siteList[0]._id;
        this._getAttributeList();
      } else {
        const site = JSON.parse(sessionStorage.getItem('siteId') || '{}');
        if (site) {
          this.siteList = this.siteList.filter((item: any) => item._id === site);
          this.form.patchValue({ siteId: this.siteList[0]._id });
          this.siteId = this.siteList[0]._id;
          this._getAttributeList();
        }
      }
    })
  }
  
  private _getAttributeList() {
    this._postData = {
      tab: this.tabType,
      siteId: this.siteId ? this.siteId : null,
    };
    this._attributeListSubscription = this._service.attributeList(this._postData).subscribe((res: any) => {
      if (res['status']) {
        let data: any = [];
        this.attributeIdList = [];
        this._attributeListForConfig = [];
        data = res['response']['data'];
        if (data.length > 0) {
          this._attributeListForConfig = data;
          data.forEach((element: any, index: any) => {
            this._attributeListForConfig[index]['textvalue'] = JSON.stringify(element['values'])
            let d: any = { id: index, name: element['attribute'] + '-' + element['description'] }
            this.attributeIdList = this.attributeIdList.concat(d);
            this._configIds = true;
          });
        }
        else {
          this._configIds = false;
          this.attributeIdList.length = 0;
        }
      }
    })
  }

  private _loadAttributeData() {
    if (this._selectedItems >= 0) {
      let arr = this._attributeListForConfig[this._selectedItems];
      if (arr) {
        this.formValues['attribute'].patchValue(arr.attribute);
        this.formValues['attributeList'].patchValue(this._selectedItems);
        this.formValues['description'].patchValue(arr.description);
        this.formValues['uom'].patchValue(arr.uom);
        this.formValues['mandatory'].patchValue(arr.mandatory);
        this.formValues['rangemin'].patchValue(arr.range['min']);
        this.formValues['rangemax'].patchValue(arr.range['max']);
        this.formValues['values'].patchValue(JSON.stringify(arr.values));
        this.selectedStatus = arr.mandatory;
      }
    }
  }

  private _patchValues() {
    if (this.configurationAdd) {
      this.form.patchValue({
        type: 'global',
        uom: 'array',
        rangemin: null,
        rangemax: null,
        mandatory: this.form.value.mandatory
      });
      switch (this.tabType) {
        case 'site':
          this.form.controls['type'].removeValidators(Validators.required);
          this.form.controls['type'].updateValueAndValidity();

          this.form.controls['attribute'].disable();
          this.form.controls['description'].disable();
          this.form.controls['uom'].disable();
          this.form.controls['mandatory'].disable();
          this.form.controls['rangemin'].disable();
          this.form.controls['rangemin'].disable();
          break;
        case 'tenant':
          this.form.controls['siteId'].removeValidators(Validators.required);
          this.form.controls['siteId'].updateValueAndValidity();
          this.form.controls['type'].removeValidators(Validators.required);
          this.form.controls['type'].updateValueAndValidity();

          this.form.controls['attribute'].disable();
          this.form.controls['description'].disable();
          this.form.controls['uom'].disable();
          this.form.controls['mandatory'].disable();
          this.form.controls['rangemin'].disable();
          this.form.controls['rangemin'].disable();
          break;
        case 'global':
          this.form.controls['siteId'].removeValidators(Validators.required);
          this.form.controls['siteId'].updateValueAndValidity();
          this.form.controls['attributeList'].removeValidators(Validators.required);
          this.form.controls['attributeList'].updateValueAndValidity();
          break;
        default:
          break;
      }
    } else {
      this.form.patchValue({
        attribute: this.configurationData.attribute,
        mandatory: this.configurationData.mandatory,
        description: this.configurationData.description,
        type: this.configurationData.type,
        uom: this.configurationData.uom,
        rangemin: null,
        rangemax: null,
        values: JSON.stringify(JSON.parse(this.configurationData['values']), null, 4)
      });
      this.selectedStatus = this.configurationData.mandatory;
      if (this.tabType === 'site' || this.tabType === 'tenant') {
        this.form.controls['siteId'].removeValidators(Validators.required);
        this.form.controls['siteId'].updateValueAndValidity();
        this.form.controls['type'].removeValidators(Validators.required);
        this.form.controls['type'].updateValueAndValidity();
        this.form.controls['attributeList'].removeValidators(Validators.required);
        this.form.controls['attributeList'].updateValueAndValidity();

        this.form.controls['attribute'].disable();
        this.form.controls['description'].disable();
        this.form.controls['uom'].disable();
        this.form.controls['mandatory'].disable();
        this.form.controls['rangemin'].disable();
        this.form.controls['rangemin'].disable();
      } else {
        this.form.controls['siteId'].removeValidators(Validators.required);
        this.form.controls['siteId'].updateValueAndValidity();
        this.form.controls['attributeList'].removeValidators(Validators.required);
        this.form.controls['attributeList'].updateValueAndValidity();
      }
    }
  }

  private _saveConfiguration() {
    this.errorMessage = null;
    this._loading = true;
    let postData;
    let data = this.form.getRawValue();
    data.range = { min: data.rangemin, max: data.rangemax }
    data.group = this.tabType === 'global' ? 'system' : 'userdefined';
    data.metadata = {
      'createdBy': localStorage.getItem('userId') ?
        localStorage.getItem('userId') : null
    };
    delete data.rangemin;
    delete data.rangemax;
    data.tenantId = this.tabType === 'global' ? null : localStorage.getItem('tenantId');
    if (typeof data.values === 'string') {
      data.values = JSON.parse(data.values);
    }
    switch (this.tabType) {
      case 'site': data.type = 'site'
        data.siteId = data.siteId ? data.siteId : null
        break;
      case 'tenant': data.type = 'tenant'
        data.siteId = data.siteId ? data.siteId : null
        break;
      case 'global': data.type = data.type;
        data.siteId = data.siteId ? data.siteId : null
        break;
      default:
        break;
    }

    postData = { set: [data], tab: this.tabType === 'global' ? 'system' : this.tabType };

    this._saveConfigSubscription = this._service.saveConfig(postData).subscribe((result: any) => {
      if (result['status'] && result['response']) {
        if (result['status']) {
          this._service.toasterService({ type: 'success', msg: result['response']['message'] });
          this._loading = false;
          this._activeModal.close(true);
        } else {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      } else {
        if (result['response']) {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      }
    });
  }

  private _updateConfiguration() {
    this.errorMessage = null;
    this._loading = true;
    let postData;

    if (typeof this.form.value.values === 'string') {
      this.form.value.values = JSON.parse(this.form.value.values);
    }
    this.form.value.attribute = this.configurationData.attribute;
    this.form.value.description = this.configurationData.description;
    postData = { configurationId: this.configurationData['_id'], set: this.form.value, tab: this.tabType === 'global' ? 'system' : this.tabType };

    this._saveSubscription = this._service.saveConfig(postData).subscribe((result: any) => {
      if (result['status'] && result['response']) {
        if (result['status']) {
          this._service.toasterService({ type: 'success', msg: result['response']['message'] });
          this._loading = false;
          this._activeModal.close(true);
        } else {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      } else {
        if (result['response']) {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      }
    });
  }

}
